import React from 'react'
import AppRouter from 'Router'
import PageViewTracker from 'Analytics/PageViewTracker'

import { ToastContainer } from 'react-toastify'
import Auth from 'Auth'
import Config from 'Config'
import Modal from 'Modal'
import ErrorBoundary from 'shared/components/ErrorBoundary'
import 'react-toastify/dist/ReactToastify.css'

export class App extends React.Component {
  constructor() {
    super()
  }
  render() {
    return (
      <ErrorBoundary>
        <Auth>
          <Modal>
            <Config>
              <PageViewTracker />
              <ToastContainer />
              <AppRouter />
            </Config>
          </Modal>
        </Auth>
      </ErrorBoundary>
    )
  }
}

export default App
